import { Menu, pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StickyMenuItem = styled(Menu.Item) `
  ${({ $sticky }) => $sticky &&
    `
      position: sticky;
      top: 0;
      bottom: 0;
  `};
`;
export const SearchableMenuInputContainer = styled.div `
  display: flex;
  align-items: center;
  padding-top: ${theme.spacing.sm};
  padding-bottom: ${theme.spacing.sm};
  padding-left: ${theme.spacing.xl};
  border-radius: ${theme.borderRadius.md};
  border: ${pxToRem(1)} solid ${theme.semantic.border.default};
  transition: border-color 0.2s ease-in-out;

  &:hover {
    border-color: ${theme.semantic.border.strong};
  }
`;
export const SearchInputElement = styled.input `
  display: flex;
  flex-grow: 1;
  font-size: ${theme.fontSize.medium};
  line-height: ${theme.lineHeight.default};
  color: ${theme.semantic.text[100]};
  padding: ${theme.spacing.md};
  outline: none;
  border: none;
  transition: color 0.2s ease-in-out;

  &:hover {
    cursor: text;
    color: ${theme.semantic.foreground.secondary};
  }
`;
